<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>
<ng-template #lazyLoadPanelContent>
  <span *nfLoader="loadingData"
    ><ngb-accordion
      [destroyOnHide]="false"
      *ngIf="
        externalTransactionId != null || clearwaterTransactionId != null;
        else noTransactionSelected
      "
    >
      <ngb-panel id="source-data" title="Source Data" [disabled]="isMultiMatch">
        <ng-template ngbPanelContent>
          <hs-external-transaction-detail-grid
            *ngIf="!isMultiMatch"
            [externalTransactionId]="externalTransactionId"
            [clearwaterTransactionId]="clearwaterTransactionId"
            (loadingData)="setloadingData($event)"
          >
          </hs-external-transaction-detail-grid>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="clearwater-transaction" title="Clearwater Transaction">
        <ng-template ngbPanelContent>
          <hs-clearwater-transaction-detail-grid
            [clearwaterTransactionId]="clearwaterTransactionId"
            (loadingData)="setloadingData($event)"
          >
          </hs-clearwater-transaction-detail-grid>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </span>
  <div></div>
  <div class="modal-footer"></div>
  <div>
    <ng-template #noTransactionSelected>
      <hs-panel-card header="No Transaction Selected">
        <p>
          This panel requires a transaction to be selected before information
          can be displayed. Select a transaction from Clearwater Transaction or
          External Transaction panel to continue.
        </p>
      </hs-panel-card>
    </ng-template>
  </div>
</ng-template>
